import type { Role } from '@death-star/shared';

export interface UserRow {
  email: string;
  role: Role;
  granted_by?: string;
  granted_at?: string;
  updated_at?: string;
}

export function isOnlySuperAdmin(users: UserRow[], targetEmail: string): boolean {
  const superAdmins = users.filter((u) => u.role === 'superAdmin');
  return superAdmins.length === 1 && superAdmins[0]?.email === targetEmail;
}
